const diminishingToggleControl = document.getElementById("diminishing");
const periodInputControl = document.getElementById("period");

if (diminishingToggleControl && periodInputControl) {
    diminishingToggleControl.addEventListener("change", (e) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            periodInputControl.disabled = false;
        } else {
            periodInputControl.disabled = true;
        }
    });
}
